import Vue from "vue";
import VueI18n from "vue-i18n";

import { EN, FR, ES, ZH_HANS, ZH_HANT, JA } from "./messages";
import Options from "@/options";

Vue.use(VueI18n);

const messages = {
  en: EN,
  fr: FR,
  es: ES,
  "zh-Hans": ZH_HANS,
  "zh-Hant": ZH_HANT,
  ja: JA,
};

let locale = "en";
try {
  const state = JSON.parse(localStorage.getItem(Options.stateKeyInLS) || "");
  locale = state.settings.lang;
} catch (e) {}

const i18n = new VueI18n({
  locale,
  fallbackLocale: "en", // set fallback locale
  messages, // set locale messages
});

export default i18n;
